

















































































































export default function (Component) {
  Component.options.__source = "src/components/d2-container-company-default/index.vue"
}
